<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 470px">
      <div id="main_area">
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>受理申報機關：</td>
                  <td>
                    <select
                      v-model="form.govCode1"
                      style="min-width: 200px"
                      @change="GovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode2"
                      style="min-width: 200px"
                      @change="GovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode3"
                      style="min-width: 200px"
                      @change="GovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.govCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.idn" />
                  </td>
                </tr>
                <tr>
                  <td>帳號：</td>
                  <td>
                    <input type="text" maxlength="20" v-model="form.id" />
                  </td>
                </tr>
                <tr>
                  <td>姓名：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td>在職狀態</td>
                  <td>
                    <select v-model="form.now_st">
                      <option value="1">在職</option>
                      <option value="2">離職</option>
                    </select>
                  </td>
                  <!--<td>角色群組：</td>
                  <td>
                    <select v-model="form.jobstatus" style="min-width: 480px">
                      <option
                        v-for="(item, index) in dropDownList.onRoleSeqs"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </td>-->
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="
                        () => {
                          this.form.currentpage = 1;
                          this.form.pagesize = 10;
                          this.doQuery();
                        }
                      "
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="新增"
                      v-show="
                        loginInfo.roleSeq == '1' || loginInfo.roleSeq == '26'
                      "
                      @click="btnAdd()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="doClear()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 查詢結果開始-->
    <div class="information">
      <table width="100%">
        <tbody>
          <tr>
            <td></td>
            <td v-if="grid.paginaiton" align="right">
              <input
                type="button"
                value="<<"
                class="btn"
                style="height: 28px"
                @click="form.currentpage = grid.paginaiton.pageNo - 1"
                v-show="grid.paginaiton.pageNo > 1"
              />
              <span
                v-for="(data, index) in grid.paginaiton.pages"
                :key="index"
                style="cursor: pointer"
                :style="
                  grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                "
                @click="form.currentpage = parseInt(data)"
              >
                {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
              </span>
              <input
                type="button"
                class="btn"
                value=">>"
                style="height: 28px"
                v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                @click="form.currentpage = grid.paginaiton.pageNo + 1"
              />
              ［每頁<input
                type="text"
                v-model.number.lazy="form.pagesize"
                size="2"
                maxlength="4"
              />

              <input type="button" class="btn" value="筆" />，第<input
                type="text"
                v-model.number.lazy="form.currentpage"
                size="2"
                maxlength="4"
              />
              <input type="button" class="btn" value="頁" />，共
              {{ grid.paginaiton.totalPage }} 頁
              {{ grid.paginaiton.totalCount }} 筆］
            </td>
          </tr>
        </tbody>
      </table>
      <div class="active">
        <div class="table_scroll2">
          <table width="1060" class="itable">
            <thead>
              <tr>
                <th colspan="2">操作</th>
                <th style="min-width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('id', Sort);
                      }
                    "
                    >帳號</u
                  >
                </th>
                <th style="min-width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('name', Sort);
                      }
                    "
                    >姓名</u
                  >
                </th>
                <th style="min-width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('idn', Sort);
                      }
                    "
                    >身分證統一編號</u
                  >
                </th>
                <th style="min-width: 100px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('GOV_CODE', Sort);
                      }
                    "
                    >受理申報機關</u
                  >
                </th>
                <th style="min-width: 70px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('title', Sort);
                      }
                    "
                    >職稱</u
                  >
                </th>
                <th style="min-width: 70px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('tel', Sort);
                      }
                    "
                    >聯絡電話</u
                  >
                </th>
                <th style="min-width: 70px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('arrive_DATE', Sort);
                      }
                    "
                    >到職日</u
                  >
                </th>
                <th style="width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('note', Sort);
                      }
                    "
                    >備註</u
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in grid.gridDatas" :key="index">
                <td width="1%" align="center">
                  <input v-if="gov_code != data.goV_CODE || loginInfo.rolE_SEQ == '1'" type="button" class="btn" @click="btnEdit(data)" value="編" />
                  <input v-else type="button" class="btn" @click="btnView(data)" value="查" />
                </td>
                <td width="1%" align="center">
                  <input type="button" class="btn" @click="btnDelete(data)" value="刪" :disabled="gov_code==data.goV_CODE"/>
                </td>
                <td>{{ data.id }}</td>
                <td>{{ data.name }}</td>
                <td>{{ data.idn }}</td>
                <td>{{ data.goV_CODE_NAME }}</td>
                <td>{{ data.title }}</td>
                <td>{{ data.tel }}</td>
                <td>{{ data.arrivE_DATE_STR }}</td>
                <td>{{ data.note }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 查詢結果結束-->
    <PdisFooter />

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.govCode1"
                    style="min-width: 200px"
                    @change="modalGovCode1Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      1 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.govCode2"
                    style="min-width: 200px"
                    @change="modalGovCode2Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      2 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.govCode3"
                    style="min-width: 200px"
                    @change="modalGovCode3Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      3 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.govCode4"
                    style="min-width: 200px"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      4 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>帳號</td>
                <td colspan="3">
                  <input
                    type="text"
                    v-model="DetailModal.form.id"
                    maxlength="20"
                    :disabled="DetailModal.modifyType == 'U'"
                  />
                  <input title="使用者忘記密碼，可使用本功能初始化密碼" type="button" class="btn" value="密碼初始化" @click="btnDetailPwSave()" disabled />
                  <!-- :disabled="DetailModal.modifyType == 'I'"
                  <input title="使用者忘記密碼，可使用本功能初始化密碼"
                  onclick="alert('密碼初始化，將寄EMAIL通知使用者，是否確定執行?')"
                  value="" data-toggle="modal" data-target=".bs-example-modal-lg">-->
                </td>
              </tr>
              <tr>
                <td>姓名</td>
                <td>
                  <input type="text" v-model="DetailModal.form.name" />
                </td>
                <td>身分證統一編號</td>
                <td>
                  <input
                    type="text"
                    v-model="DetailModal.form.idn"
                  /><!--:disabled="DetailModal.modifyType == 'U'"-->
                </td>
              </tr>
              <tr>
                <td>生日</td>
                <td colspan="3">
                  <DatePicker
                    v-model="DetailModal.form.birthday"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  /><br />
                </td>
              </tr>
              <tr>
                <td>職稱</td>
                <td>
                  <input type="text" v-model="DetailModal.form.title" />
                </td>
                <td>階級</td>
                <td>
                  <select v-model="DetailModal.form.rank">
                    <option value="">無</option>
                    <option value="1">上將</option>
                    <option value="2">中將</option>
                    <option value="3">少將</option>
                    <option value="4">上校</option>
                    <option value="5">中校</option>
                    <option value="6">少校</option>
                    <option value="7">上尉</option>
                    <option value="8">中尉</option>
                    <option value="9">少尉</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>聯絡電話</td>
                <td>
                  <input type="text" v-model="DetailModal.form.tel" />
                </td>
                <td>E-Mail</td>
                <td>
                  <input
                    type="text"
                    v-model="DetailModal.form.email"
                    size="40"
                    maxlength="40"
                  />
                </td>
              </tr>
              <tr>
                <td>到職日</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.arriveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  /><br />
                </td>
                <td>在職狀態</td>
                <td>
                  <select v-model="DetailModal.form.now_st">
                    <option :value="1">在職</option>
                    <option :value="2">離職</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>角色群組</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.role_seq"
                    style="min-width: 480px"
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .onRoleSeqs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>
                  帳號狀況
                  <input
                    title="帳號被鎖定可使用本功能解鎖"
                    type="button"
                    class="btn"
                    value="解鎖"
                    @click="btnDetailFlagSave()"
                    v-show="DetailModal.form.loginFlag >= 3"
                    :disabled="DetailModal.modifyType == 'I'"
                  />
                </td>
                <td>
                  <input
                    type="radio"
                    name="RadioGroup1"
                    value="Y"
                    v-model="DetailModal.form.admin_flag"
                    checked="checked"
                  />啟用
                  <input
                    type="radio"
                    name="RadioGroup1"
                    value="N"
                    v-model="DetailModal.form.admin_flag"
                  />停用
                  <span v-if="DetailModal.form.loginFlag >= 3">
                    <input
                      type="radio"
                      name="RadioGroup1"
                      disabled="disabled"
                      v-model="DetailModal.form.admin_flag"
                      value=""
                    />
                    鎖住(登入密碼錯誤達三次以上)
                  </span>
                  <span v-else style="margin-left: 10px">
                    登入密碼錯誤 {{ DetailModal.form.loginFlag }} 次
                  </span>
                </td>
              </tr>
              <!--<tr>
                <td>應申報身分資格</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.status"
                    style="max-width: 1000px"
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .OnDeclare"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>-->
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="DetailModal.form.note"
                      size="80"
                      maxlength="80"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input type="submit" class="btn" value="存檔" v-show="(loginInfo.roleSeq == '1' || loginInfo.roleSeq == '26') && DetailModal.modifyType != 'V'" @click="btnDetailSave()" />
                      <input type="submit" class="btn" value="重填" v-show="DetailModal.modifyType != 'V'" @click="btnDetailClear()" :disabled="DetailModal.modifyType == 'U'" /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </DetailModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <AlertDel v-model="AlertDel.show" :title="AlertDel.title">
      <div style="text-align: center">
        <p>確定要刪除資料嗎?</p>
        <div>
          <button class="btn" @click="btnDelSubmit()">確定</button>
          <button class="btn" @click="AlertDel.show = false">取消</button>
        </div>
      </div>
    </AlertDel>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { ChkIDorRCNumber, getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  SearchGovCode,
  SearchGridOnRoleSeq,
  S305_SearchGrid,
  S305_ReSearchGrid,
  S305_Delete,
  S305_Detail,
  S305_DetailAddSave,
  S305_DetailEditPwSave,
  S305_DetailEditFlagSave,
  S305_DetailEditSave,
} from "@/service/api.js";
export default {
  name: "S305",
  data: function () {
    return {
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S305",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      gov_code: "",
      form: {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "0",
        id: "",
        idn: "",
        name: "",
        now_st: "",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
        //角色群組
        onRoleSeqs: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "S305 政風單位資料維護",
        form: {
          govCode1: "",
          govCode2: "",
          govCode3: "",
          govCode4: "",
          id: "",
          idn: "",
          name: "",
          birthday: "",
          title: "",
          rank: "",
          tel: "",
          email: "",
          arriveDate: "",
          //角色群組
          role_seq: "",
          //登入狀態
          loginFlag: 0,
          //啟用狀態
          admin_flag: "Y",
          //備註
          note: "",
          now_st: "",
        },
        modifyType: "", //"I,U"
        dropDownList: {
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          onRoleSeqs: [],
        },
        PreData: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      AlertDel: {
        show: false,
        title: "",
        form: {
          pkno: 0,
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    AlertDel: VueModal,
    DetailModal: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    //取得受理申報機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得角色群組
    getOnRoleSeq: function () {
      const self = this;
      SearchGridOnRoleSeq({}).then((rData) => {
        self.dropDownList.onRoleSeqs = [{ value: "", text: "" }].concat(
          rData.returnObject
        );
      });
    },
    //取得受理申報機關第一層類別 DetailModal
    modalGetSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別 DetailModal
    modalGetSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別 DetailModal
    modalGetSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別 DetailModal
    modalGetSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得角色群組 DetailModal
    modalGetOnRoleSeq: function () {
      const self = this;
      SearchGridOnRoleSeq({}).then((rData) => {
        self.DetailModal.dropDownList.onRoleSeqs = [
          { value: "", text: "" },
        ].concat(rData.returnObject);
      });
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
       //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        GOV: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOVCHECK: parseInt(self.form.govCheck),
        ID: self.form.id,
        IDN: self.form.idn,
        NAME: self.form.name,
        NOW_ST: self.form.now_st,
        ROLESEQ:
          self.loginInfo && self.loginInfo.roleSeq
            ? self.loginInfo.roleSeq
            : null,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      self.gov_code = postData.GOV;
      S305_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "idn";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        GOV: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOVCHECK: parseInt(self.form.govCheck),
        ID: self.form.id,
        IDN: self.form.idn,
        NAME: self.form.name,
        NOW_ST: self.form.now_st,
        ROLESEQ:
          self.loginInfo && self.loginInfo.roleSeq
            ? self.loginInfo.roleSeq
            : null,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      S305_ReSearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁重填
    doClear: function () {
      const self = this;
      self.form = {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "0",
        idn: "",
        name: "",
        jobstatus: "",
        currentpage: 1,
        pagesize: 10,
      };
      self.GovCodeInit(self.form);
      self.getSearchGovCode1();
    },
    GovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.govCode1 = self.SessionGovCode;
        form.govCode2 = "";
        form.govCode3 = "";
        form.govCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.govCode1 = govCodeArray[0];
          form.govCode2 = govCodeArray[1];
          form.govCode3 = govCodeArray[2];
          form.govCode4 = govCodeArray[3];
        }
      }
    },
    GovCode1Change: function () {
      const self = this;
      self.form.govCode2 = "";
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode2s = [];
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode2Change: function () {
      const self = this;
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode3Change: function () {
      const self = this;
      self.form.govCode4 = "";
      self.dropDownList.govCode4s = [];
    },
    modalGovCode1Change: function () {
      const self = this;
      self.DetailModal.form.govCode2 = "";
      self.DetailModal.form.govCode3 = "";
      self.DetailModal.form.govCode4 = "";
      self.DetailModal.dropDownList.govCode2s = [];
      self.DetailModal.dropDownList.govCode3s = [];
      self.DetailModal.dropDownList.govCode4s = [];
    },
    modalGovCode2Change: function () {
      const self = this;
      self.DetailModal.form.govCode3 = "";
      self.DetailModal.form.govCode4 = "";
      self.DetailModal.dropDownList.govCode3s = [];
      self.DetailModal.dropDownList.govCode4s = [];
    },
    modalGovCode3Change: function () {
      const self = this;
      self.DetailModal.form.govCode4 = "";
      self.DetailModal.dropDownList.govCode4s = [];
    },
    //第一頁新增
    btnAdd: function () {
      const self = this;
      self.DetailModal.PreData = {};
      self.DetailModal.modifyType = "I";
      self.btnDetailClear();
      self.DetailModalInit();
      self.DetailModal.title = "S305 政風單位資料維護-新增";
      self.DetailModal.show = true;
    },
    //第一頁匯入
    btnImport: function () {
      const self = this;
      self.ImportModal.show = true;
    },
    //第一頁匯出
    btnExport: function () {
      const self = this;
      self.ExportModal.show = true;
      self.ExportModalBtnClear();
      self.ExportModal.dropDownList.syears =
        self.ExportModalGetSyearDropDownList();
      self.ExportModalGetSearchJobGovCode2(self.ExportModal.form.jobGovCode1);
      self.ExportModal.dropDownList.onRoleSeqs = self.ExportModalGetOnRoleSeq();
    },
    //gird
    //第一頁編
    btnEdit: function (data) {
      const self = this;
      self.DetailModal.PreData = data;
      self.getDetailData();
      self.modalGetSearchGovCode1();
      self.DetailModalInit();
      self.DetailModal.modifyType = "U";
      self.DetailModal.title = "S305 政風單位資料維護-編輯";
      self.DetailModal.show = true;
    },
    //第一頁查看
    btnView: function (data) {
      const self = this;
      self.DetailModal.PreData = data;
      self.getDetailData();
      self.modalGetSearchGovCode1();
      self.DetailModalInit();
      self.DetailModal.modifyType = "V";
      self.DetailModal.title = "S305 政風單位資料維護-查看";
      self.DetailModal.show = true;
    },
    //第一頁刪
    btnDelete: function (data) {
      const self = this;
      this.AlertDel.show = true;
      this.AlertDel.title = "提醒";
      this.AlertDel.form.pkno = data.pkno;
    },
    btnDelSubmit: function () {
      const self = this;
      let postData = {
        pkno: self.AlertDel.form.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S305_Delete(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.doQuery();
            self.Alert.show = false;
            self.AlertDel.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          //self.Alert.txt = "刪除失敗";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.AlertDel.show = false;
          };
        }
      });
    },
    //第一頁受理申報機關變動
    btnGovCodeEdit: function (data) {
      const self = this;
      //init
      self.govModalGetOnRoleSeq();
      self.govModalGetSearchJobGovCode2(self.GovCodeModal.form.jobGovCode1);
      self.govModalGetSearchNewJobGovCode1();
      self.govModalGetSearchNewJobGovCode2(
        self.GovCodeModal.form.newJobGovCode1
      );

      self.GovCodeModal.PreData = data;
      self.getGovModalData();
      self.GovCodeModal.show = true;
    },
    //第一頁受理申報機關變動紀錄
    btnSearchLog: function (idn) {
      const self = this;
      self.LogModal.form.idn = idn;
      let postData = {
        idn: idn,
        currentpage: 1,
        pagesize: 10,
      };
      S305_SearchLog(postData).then((rData) => {
        self.LogModal.grid = rData.returnObject;
        self.LogModal.show = true;
      });
    },
    //第二頁明細init
    DetailModalInit: function () {
      const self = this;
      self.modalGetOnRoleSeq();
    },
    //第二頁明細內容 API
    getDetailData: function () {
      const self = this;
      for (var i = 0; i < 3; i++) {
        let postData = {
          pkno: self.DetailModal.PreData.pkno,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "編",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S305_Detail(postData).then((rData) => {
          if (rData.result) {
            self.DetailModal.grid = rData.returnObject;
            self.DetailModal.form = {
              govCode1: self.DetailModal.grid.govCodeStr.split(",")[0],
              govCode2: self.DetailModal.grid.govCodeStr.split(",")[1],
              govCode3: self.DetailModal.grid.govCodeStr.split(",")[2],
              govCode4: self.DetailModal.grid.govCodeStr.split(",")[3],
              id: self.DetailModal.grid.id,
              idn: self.DetailModal.grid.idn,
              name: self.DetailModal.grid.name,
              birthday: self.DetailModal.grid.birthday,
              title: self.DetailModal.grid.title,
              rank: self.DetailModal.grid.rank,
              tel: self.DetailModal.grid.tel,
              email: self.DetailModal.grid.email,
              //arriveDate: self.$moment(self.DetailModal.grid.arriveDate)._d,
              arriveDate: self.DetailModal.grid.arriveDate,
              //角色群組
              role_seq: self.DetailModal.grid.role_Seq,
              //啟用狀態
              admin_flag: self.DetailModal.grid.admin_Flag,
              //登入狀態
              loginFlag: self.DetailModal.grid.loginFlag,
              //備註
              note: self.DetailModal.grid.note,
              now_st: self.DetailModal.grid.now_St,
            };
          }
        });
      }
    },
    //第二頁明細新增 API
    S305_DetailAddSave: function () {
      const self = this;
      let postData = {
        pkno: 0,
        goV_CODE: self.DetailModal.form.govCode4
          ? self.DetailModal.form.govCode4
          : self.DetailModal.form.govCode3
          ? self.DetailModal.form.govCode3
          : self.DetailModal.form.govCode2
          ? self.DetailModal.form.govCode2
          : self.DetailModal.form.govCode1
          ? self.DetailModal.form.govCode1
          : "",
        goV_CODE_STR:
          self.DetailModal.form.govCode1 +
          "," +
          self.DetailModal.form.govCode2 +
          "," +
          self.DetailModal.form.govCode3 +
          "," +
          self.DetailModal.form.govCode4,
        id: self.DetailModal.form.id,
        idn: self.DetailModal.form.idn,
        name: self.DetailModal.form.name,
        rank: self.DetailModal.form.rank,
        tel: self.DetailModal.form.tel,
        email: self.DetailModal.form.email,
        birthday: self.DetailModal.form.birthday,
        title: self.DetailModal.form.title,
        userid: self.loginInfo.id,
        arrivE_DATE: self
          .$moment(self.DetailModal.form.arriveDate)
          .format("YYYY/MM/DD"),
        //角色群組
        rolE_SEQ: self.DetailModal.form.role_seq.toString(),
        //啟用狀態
        admiN_FLAG: self.DetailModal.form.admin_flag,
        //備註
        note: self.DetailModal.form.note,
        noW_ST: self.DetailModal.form.now_st,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細新增",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S305_DetailAddSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["新增成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            //self.DetailModal.show = false;
            self.btnDetailClear();
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          //self.Alert.txt = "新增失敗";
          self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
        //console.log(rData);
      });
    },
    //第二頁明細修改 API
    S305_DetailEditSave: function () {
      const self = this;
      let postData = {
        pkno: self.DetailModal.PreData.pkno,
        goV_CODE: self.DetailModal.form.govCode4
          ? self.DetailModal.form.govCode4
          : self.DetailModal.form.govCode3
          ? self.DetailModal.form.govCode3
          : self.DetailModal.form.govCode2
          ? self.DetailModal.form.govCode2
          : self.DetailModal.form.govCode1
          ? self.DetailModal.form.govCode1
          : "",
        goV_CODE_STR:
          self.DetailModal.form.govCode1 +
          "," +
          self.DetailModal.form.govCode2 +
          "," +
          self.DetailModal.form.govCode3 +
          "," +
          self.DetailModal.form.govCode4,
        id: self.DetailModal.form.id,
        idn: self.DetailModal.form.idn,
        name: self.DetailModal.form.name,
        rank: self.DetailModal.form.rank,
        tel: self.DetailModal.form.tel,
        email: self.DetailModal.form.email,
        birthday: self.DetailModal.form.birthday,
        title: self.DetailModal.form.title,
        userid: self.loginInfo.id,
        arrivE_DATE: self
          .$moment(self.DetailModal.form.arriveDate)
          .format("YYYY/MM/DD"),
        //角色群組
        rolE_SEQ: self.DetailModal.form.role_seq.toString(),
        //啟用狀態
        admiN_FLAG: self.DetailModal.form.admin_flag,
        //備註
        note: self.DetailModal.form.note,
        noW_ST: self.DetailModal.form.now_st,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S305_DetailEditSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          //self.Alert.txt = "修改失敗";
          self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁明細修改密碼 API
    S305_DetailEditPwSave: function () {
      const self = this;
      let postData = {
        pkno: self.DetailModal.PreData.pkno,
        goV_CODE: self.DetailModal.form.govCode4
          ? self.DetailModal.form.govCode4
          : self.DetailModal.form.govCode3
          ? self.DetailModal.form.govCode3
          : self.DetailModal.form.govCode2
          ? self.DetailModal.form.govCode2
          : self.DetailModal.form.govCode1
          ? self.DetailModal.form.govCode1
          : "",
        goV_CODE_STR:
          self.DetailModal.form.govCode1 +
          "," +
          self.DetailModal.form.govCode2 +
          "," +
          self.DetailModal.form.govCode3 +
          "," +
          self.DetailModal.form.govCode4,
        id: self.DetailModal.form.id,
        idn: self.DetailModal.form.idn,
        name: self.DetailModal.form.name,
        rank: self.DetailModal.form.rank,
        tel: self.DetailModal.form.tel,
        email: self.DetailModal.form.email,
        birthday: self.DetailModal.form.birthday,
        title: self.DetailModal.form.title,
        userid: self.loginInfo.id,
        arrivE_DATE: self
          .$moment(self.DetailModal.form.arriveDate)
          .format("YYYY/MM/DD"),
        //角色群組
        role_seq: self.DetailModal.form.role_seq.toString(),
        //啟用狀態
        admin_flag: self.DetailModal.form.admin_flag,
        //備註
        note: self.DetailModal.form.note,
        now_st: self.DetailModal.form.now_st,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改密碼",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S305_DetailEditPwSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          //self.Alert.txt = "修改失敗";
          self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁明細修改狀態 API
    S305_DetailEditFlagSave: function () {
      const self = this;
      let postData = {
        pkno: self.DetailModal.PreData.pkno,
        goV_CODE: self.DetailModal.form.govCode4
          ? self.DetailModal.form.govCode4
          : self.DetailModal.form.govCode3
          ? self.DetailModal.form.govCode3
          : self.DetailModal.form.govCode2
          ? self.DetailModal.form.govCode2
          : self.DetailModal.form.govCode1
          ? self.DetailModal.form.govCode1
          : "",
        goV_CODE_STR:
          self.DetailModal.form.govCode1 +
          "," +
          self.DetailModal.form.govCode2 +
          "," +
          self.DetailModal.form.govCode3 +
          "," +
          self.DetailModal.form.govCode4,
        id: self.DetailModal.form.id,
        idn: self.DetailModal.form.idn,
        name: self.DetailModal.form.name,
        rank: self.DetailModal.form.rank,
        tel: self.DetailModal.form.tel,
        email: self.DetailModal.form.email,
        birthday: self.DetailModal.form.birthday,
        title: self.DetailModal.form.title,
        userid: self.loginInfo.id,
        arrivE_DATE: self
          .$moment(self.DetailModal.form.arriveDate)
          .format("YYYY/MM/DD"),
        //角色群組
        role_seq: self.DetailModal.form.role_seq.toString(),
        //啟用狀態
        admin_flag: self.DetailModal.form.admin_flag,
        //備註
        note: self.DetailModal.form.note,
        now_st: self.DetailModal.form.now_st,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改狀態",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S305_DetailEditFlagSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          //self.Alert.txt = "修改失敗";
          self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁按紐明細存檔
    btnDetailSave: function () {
      const self = this;
      let errorMsg = [];
      if (self.DetailModal.form.idn.trim() == "") {
        errorMsg.push("請填寫身分證統一編號");
      } else if (!ChkIDorRCNumber(self.DetailModal.form.idn)) {
        errorMsg.push("身分證統一編號格式不對");
      }
      if (self.DetailModal.form.govCode1 == "") {
        errorMsg.push("請填寫單位");
      }
      if (self.DetailModal.form.email.trim() == "") {
        errorMsg.push("請填寫Email");
      } else if (!(self.DetailModal.form.email.indexOf("@") > -1)) {
        errorMsg.push("Email格式錯誤");
      }
      if (self.DetailModal.form.id.trim() == "") {
        errorMsg.push("請填寫帳號");
      }
      if (self.DetailModal.form.title.trim() == "") {
        errorMsg.push("請填寫單位職稱");
      }
      if (self.DetailModal.form.name.trim() == "") {
        errorMsg.push("請填寫姓名");
      }
      if (self.DetailModal.form.birthday == "") {
        errorMsg.push("請填寫生日");
      } else if (
        self.$moment(new Date()).isBefore(self.DetailModal.form.birthday)
      ) {
        errorMsg.push("生日不可大於系統日");
      } else if (
        new Date(self.DetailModal.form.birthday).getFullYear() >
        new Date(Date.now()).getFullYear() - 18
      ) {
        errorMsg.push("生日錯誤(生日之人尚未成年)");
      }
      if (self.DetailModal.form.arriveDate == "") {
        errorMsg.push("請填寫到職日");
      } else if (
        self.$moment(Date.now()).isBefore(self.DetailModal.form.arriveDate)
      ) {
        errorMsg.push("到職日不可填寫未來日");
      }
      if (self.DetailModal.form.admin_flag == "") {
        errorMsg.push("請填寫在職狀態");
      }
      if (self.DetailModal.form.now_st == "") {
        errorMsg.push("請填寫在職狀態");
      }
      if (self.DetailModal.form.role_seq == "") {
        errorMsg.push("請填寫角色群組");
      } else {
        if (
          self.loginInfo.roleSeq != 1 &&
          self.DetailModal.form.role_seq == 1
        ) {
          errorMsg.push("非系統管理員權限，不能更改角色群組至系統管理員");
        }
      }
      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }
      if (self.DetailModal.modifyType == "I") {
        self.S305_DetailAddSave();
      } else if (self.DetailModal.modifyType == "U") {
        self.S305_DetailEditSave();
      }
    },
    btnDetailPwSave: function () {
      const self = this;
      if (self.DetailModal.modifyType == "U") {
        self.S305_DetailEditPwSave();
      }
    },
    btnDetailFlagSave: function () {
      const self = this;
      if (self.DetailModal.modifyType == "U") {
        self.S305_DetailEditFlagSave();
      }
    },
    //第二頁明細重填
    btnDetailClear: function () {
      const self = this;
      self.DetailModal.form = {
        govCode1: self.DetailModal.form.govCode1, //"311000000F"
        govCode2: "",
        govCode3: "",
        govCode4: "",
        jobGovCode1: self.DetailModal.form.jobGovCode1,
        jobGovCode2: self.DetailModal.form.jobGovCode2,
        jobGovCode3: self.DetailModal.form.jobGovCode3,
        jobGovCode4: self.DetailModal.form.jobGovCode4,
        id: self.DetailModal.modifyType == "U" ? self.DetailModal.form.id : "",
        idn:
          self.DetailModal.modifyType == "U" ? self.DetailModal.form.idn : "",
        name: "",
        birthday: "",
        title: "",
        rank: "",
        tel: "",
        email: "",
        arriveDate: "",
        //角色群組
        role_seq: "",
        //登入狀態
        loginFlag: self.DetailModal.form.loginFlag,
        //啟用狀態
        admin_flag: "Y",
        //備註
        note: "",
        now_st: "",
      };
      self.GovCodeInit(self.DetailModal.form);
      self.modalGetSearchGovCode1();
    },
    //第三頁 機關變動 API
    getGovModalData: function () {
      const self = this;
      S305_Detail({ pkno: self.GovCodeModal.PreData.pkno }).then((rData) => {
        if (rData.result) {
          self.GovCodeModal.grid = rData.returnObject;
          self.GovCodeModal.form = {
            govCode1: self.GovCodeModal.grid.govCodeStr.split(",")[0],
            govCode2: self.GovCodeModal.grid.govCodeStr.split(",")[1],
            govCode3: self.GovCodeModal.grid.govCodeStr.split(",")[2],
            govCode4: self.GovCodeModal.grid.govCodeStr.split(",")[3],
            idn: self.GovCodeModal.grid.idn,
            name: self.GovCodeModal.grid.name,
            arriveDate: self.$moment(self.GovCodeModal.grid.arriveDate)._d,
            leaveDate: self.GovCodeModal.grid.leaveDate,
            //現職狀況
            leave: self.GovCodeModal.grid.leave,
            //備註
            leave_Reason: self.GovCodeModal.grid.leaveReason,
            newJobGovCode1: sessionStorage.getItem("Session_GovCode"),
            newJobGovCode2: "",
            newJobGovCode3: "",
            newJobGovCode4: "",
          };
        }
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.GovCodeInit(self.form);
    self.getSearchGovCode1();
    self.getOnRoleSeq();
  },
  watch: {
    "form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode2(newValue);
    },
    "form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode3(newValue);
    },
    "form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "DetailModal.form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchGovCode2(newValue);
    },
    "DetailModal.form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchGovCode3(newValue);
    },
    "DetailModal.form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchGovCode4(newValue);
    },
    "DetailModal.form.idn": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.DetailModal.form.idn = newValue.toUpperCase();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
